// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as DataAttribute$Showside from "../../utils/DataAttribute.bs.js";
import * as NavMenu__Context$Showside from "./NavMenu__Context.bs.js";
import * as UseDelayedBoolean$Showside from "../../hook/UseDelayedBoolean.bs.js";
var context = React.createContext({
  activeValue: 0,
  animate: true,
  disabled: false,
  direction: /* Vertical */0
});
var provider = context.Provider;
function useContainer(param) {
  return React.useContext(context);
}
var ContainerContext = {
  context: context,
  provider: provider,
  useContainer: useContainer
};
var context$1 = React.createContext({
  value: 0,
  disabled: false
});
var provider$1 = context$1.Provider;
function useContent(param) {
  return React.useContext(context$1);
}
var ContentContext = {
  context: context$1,
  provider: provider$1,
  useContent: useContent
};
function NavMenu__Transition$Container(Props) {
  var value = Props.value;
  var direction = Props.direction;
  var animateOpt = Props.animate;
  var disabledOpt = Props.disabled;
  var children = Props.children;
  var animate = animateOpt !== undefined ? animateOpt : true;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var match = React.useContext(context);
  var match$1 = React.useContext(context$1);
  var disabled$1 = disabled || match.disabled || match$1.disabled;
  return React.createElement(provider, {
    value: {
      activeValue: value,
      animate: animate,
      disabled: disabled$1,
      direction: direction
    },
    children: children
  });
}
NavMenu__Transition$Container.displayName = "NavMenu__Transition.Container";
var Container = {
  make: NavMenu__Transition$Container
};
function NavMenu__Transition$Content(Props) {
  var value = Props.value;
  var style = Props.style;
  var dataTestId = Props.dataTestId;
  var className = Props.className;
  var children = Props.children;
  var fwdRef = Props.fwdRef;
  var match = React.useContext(context);
  var disabled = match.disabled;
  var animate = match.animate;
  var activeValue = match.activeValue;
  var ctx = NavMenu__Context$Showside.use(undefined);
  var isActive = value === activeValue && !disabled;
  var isActiveDelayed = UseDelayedBoolean$Showside.useDelayedBoolean(ctx.pageFlipTransitionSpeedMs, /* DelayFalse */1, isActive);
  var shouldRender = isActive || isActiveDelayed;
  var style$1 = React.useMemo(function () {
    var tmp = {};
    var tmp$1 = animate ? CSS$Showside.intToMs(ctx.pageFlipTransitionSpeedMs) : undefined;
    if (tmp$1 !== undefined) {
      tmp.transitionDuration = tmp$1;
    }
    var tmp$2 = animate ? "transform,opacity" : undefined;
    if (tmp$2 !== undefined) {
      tmp.transitionProperty = tmp$2;
    }
    var defaultStyle = tmp;
    if (style !== undefined) {
      return Object.assign({}, defaultStyle, Caml_option.valFromOption(style));
    } else {
      return defaultStyle;
    }
  }, [style]);
  var tmp;
  switch (match.direction) {
    case /* Vertical */0:
      tmp = value === activeValue ? "translate-y-0" : value > activeValue ? "translate-y-7" : value < activeValue ? "-translate-y-7" : "";
      break;
    case /* Horizontal */1:
      tmp = value === activeValue ? "translate-x-0" : value > activeValue ? "translate-x-7" : value < activeValue ? "-translate-x-7" : "";
      break;
    case /* NoMotion */2:
      tmp = "";
      break;
  }
  var tmp$1 = {
    className: Cn.make([CSS$Showside.prefix(Cn.make([isActive ? "opacity-100" : "opacity-0 pointer-events-none", tmp, isActive ? "relative" : "absolute h-full", "top-0 left-0 w-full transform-gpu motion-reduce:transform-none ease-linear-out-slow-in"])), Belt_Option.getWithDefault(className, "")]),
    style: style$1
  };
  if (fwdRef !== undefined) {
    tmp$1.ref = Caml_option.valFromOption(fwdRef);
  }
  var tmp$2 = isActive ? undefined : -1;
  if (tmp$2 !== undefined) {
    tmp$1.tabIndex = Caml_option.valFromOption(tmp$2);
  }
  var tmp$3 = {
    dataActive: isActive,
    children: React.createElement("div", tmp$1, shouldRender ? children : null)
  };
  if (dataTestId !== undefined) {
    tmp$3.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  var children$1 = React.createElement(React.Fragment, undefined, React.createElement(DataAttribute$Showside.make, tmp$3));
  return React.createElement(provider$1, {
    value: {
      value: value,
      disabled: disabled
    },
    children: children$1
  });
}
NavMenu__Transition$Content.displayName = "NavMenu__Transition.Content";
var Content = {
  make: NavMenu__Transition$Content
};
export { ContainerContext, ContentContext, Container, Content };
/* context Not a pure module */